/* eslint-disable react-hooks/exhaustive-deps */
import PortfolioItemContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemContext';
import useApi from '@/lib/api/useApi';
import type { CoachComment } from '@/lib/types';
import { useCallback, useContext, useState } from 'react';
import TextEditor from '../../TypeSpecificFieldRenderers/utils/TextEditor';
import Space from '@/components/Space';

type CoachCommentEditorProps = {
  coachComment: CoachComment;
  onClose: () => void;
};

const CoachCommentEditor = ({
  coachComment,
  onClose,
}: CoachCommentEditorProps) => {
  const api = useApi();

  const { setPortfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);

  const [saving, setSaving] = useState(false);

  const saveChanges = useCallback(async (newContent: string): Promise<void> => {
    setSaving(true);

    const updatedCoachComment = await api.put<CoachComment>(
      `${portfolioItemApiEndpoint}/coach-comments/${coachComment.id}`,
      {
        content: newContent,
      },
    );

    setPortfolioItem(portfolioItem => {
      portfolioItem.coachComments[coachComment.id] = {
        ...portfolioItem.coachComments[coachComment.id],
        ...updatedCoachComment,
      };
    });

    onClose();

    setSaving(false);
  }, []);

  return (
    <>
      <Space height={18} />
      <TextEditor
        initialValue={coachComment.content}
        onCancel={onClose}
        onSave={saveChanges}
        disabled={saving}
        disableSaveWhenEmpty
      />
    </>
  );
};

export default CoachCommentEditor;
